import React from 'react';
import MUITable from '@material-ui/core/Table';
import MUITableRow from '@material-ui/core/TableRow';
import MUITableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import styled from 'styled-components';
import { maxWidth } from 'styled-system';

import { COLOR, theme, FONT_SIZE } from '../Theme';

const Table = styled(({ minWidth, border, ...restProps }) => <MUITable {...restProps} />)`
  && {
    min-width: ${props => props.minWidth};
    font-family: inherit;
    border: ${props => props.border && `1px solid ${COLOR.borderGrey}`};
  }
`;

const TableCell = styled(
  ({
    color,
    bgColor,
    width,
    minWidth,
    maxWidth,
    cellBorder,
    wrap,
    verticalAlign,
    fontWeight,
    textAlign,
    empty,
    ...restProps
  }) => <MUITableCell {...restProps} />
)`
  && {
    ${props => props.empty && ` width: 0; height: 0; padding: 0;`};
    font-size: 14px;
    font-family: inherit;
    color: ${props => props.color || COLOR.greyscale.grey1};
    background-color: ${props => props.bgColor};
    white-space: ${props => !props.wrap && 'nowrap'};
    overflow: hidden;
    text-overflow: ellipsis;
    width: ${props => props.width};
    min-width: ${props => props.minWidth};
    border-right: ${props => props.cellBorder && `1px solid ${COLOR.borderGrey}`};
    vertical-align: ${props => props.verticalAlign || 'middle'};
    text-align: ${props => props.textAlign || 'left'};
    font-weight: ${props =>
      props.fontWeight ? theme.fontWeights[props.fontWeight] : theme.fontWeights.normal}
    position: relative;
    ${maxWidth}
  }
`;

const TableRow = styled(({ noBorder, cellBorder, bgColor, height, ...restProps }) => (
  <MUITableRow {...restProps} />
))`
  ${props =>
    props.cellBorder &&
    `
      td:not(:last-child),
      th:not(:last-child) {
        border-right: 1px solid ${COLOR.borderGrey};
      `}};
  ${props =>
    props.noBorder &&
    `
      td,th {
        border-bottom: none;
      }`};
  && {
    height: ${props => props.height};
    border-bottom: ${props => props.border};
    background-color: ${props => props.bgColor};
  }
`;

export { Table, TableBody, TableHead, TableFooter, TableCell, TableRow };
